import { styled } from "@linaria/react";
import type { ImageRequireType } from "../image";
import { SIZE_M, SIZE_S } from "../../constants";
import UserPresence from "../userPresence";
import FiberImage from "../image";
const Users = /*#__PURE__*/styled("div")({
  name: "Users",
  class: "u12rbd0r"
});
const User = /*#__PURE__*/styled("div")({
  name: "User",
  class: "ud81nm8"
});
const UserBob = /*#__PURE__*/styled("div")({
  name: "UserBob",
  class: "ulf8koj"
});
const User1 = /*#__PURE__*/styled(User)({
  name: "User1",
  class: "ubcg595"
});
const User2 = /*#__PURE__*/styled(User)({
  name: "User2",
  class: "uktyj0h"
});
const User3 = /*#__PURE__*/styled(User)({
  name: "User3",
  class: "u1c5zwl"
});
const User4 = /*#__PURE__*/styled(User)({
  name: "User4",
  class: "u1w4ktm3"
});
const User5 = /*#__PURE__*/styled(User)({
  name: "User5",
  class: "u10lzjiu"
});
const User6 = /*#__PURE__*/styled(User)({
  name: "User6",
  class: "umxu3te"
});
const user1 = (require("./user1.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

const user2 = (require("./user2.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

const user3 = (require("./user3.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

const user4 = (require("./user4.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

const user5 = (require("./user5.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

const user6 = (require("./user6.png?resize&format=jpg&placholder=true") as ImageRequireType); // eslint-disable-line @typescript-eslint/no-var-requires

function Heads(): JSX.Element {
  return <Users>
      <User1>
        <UserBob>
          <UserPresence color="#916FF8">
            <FiberImage src={user1.src} srcSet={user1.srcSet} width={user1.width} height={user1.height} alt="User 1" />
          </UserPresence>
        </UserBob>
      </User1>
      <User2>
        <UserBob>
          <UserPresence color="#4A78FF">
            <FiberImage src={user2.src} srcSet={user2.srcSet} width={user2.width} height={user2.height} alt="User 2" />
          </UserPresence>
        </UserBob>
      </User2>
      <User3>
        <UserBob>
          <UserPresence color="#08CD75">
            <FiberImage src={user3.src} srcSet={user3.srcSet} width={user3.width} height={user3.height} alt="User 1" />
          </UserPresence>
        </UserBob>
      </User3>
      <User4>
        <UserBob>
          <UserPresence color="#F99999">
            <FiberImage src={user4.src} srcSet={user4.srcSet} width={user4.width} height={user4.height} alt="User 4" />
          </UserPresence>
        </UserBob>
      </User4>
      <User5>
        <UserBob>
          <UserPresence color="#D3FA89">
            <FiberImage src={user5.src} srcSet={user5.srcSet} width={user5.width} height={user5.height} alt="User 5" />
          </UserPresence>
        </UserBob>
      </User5>
      <User6>
        <UserBob>
          <UserPresence color="#FF00E5">
            <FiberImage src={user6.src} srcSet={user6.srcSet} width={user6.width} height={user6.height} alt="User 6" />
          </UserPresence>
        </UserBob>
      </User6>
    </Users>;
}

export default Heads;

require("../../../.linaria-cache/src/components/homepage/heads.linaria.module.css");